import { Entity, Column, PrimaryGeneratedColumn, ManyToOne } from "typeorm";
import { AddressEntity } from "./address.entity";

@Entity()
export class CustomerEntity {

    @PrimaryGeneratedColumn()
    customerId: number;

    @Column()
    name: string;

    @Column({default: false})
    company: Boolean;

    @ManyToOne(() => AddressEntity, billingAddress => billingAddress.addressId)
    billingAddress: AddressEntity;

}